import React, { useState, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';
import axios from 'axios';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
// require('dotenv').config();
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
console.log(API_BASE_URL);

console.log("API_BASE_URL");


const Otherservices = () => {
  const [team, setTeam] = useState('');
  const [iconLink, setIconLink] = useState('');
  const [rowData, setRowData] = useState([]);
  const [errors, setErrors] = useState({ team: '', iconLink: '' });
  const [editingTeam, setEditingTeam] = useState(null);
  const [alert, setAlert] = useState({ message: '', type: '' });
  const [selectedService, setSelectedService] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/other_services`)
      .then((response) => {
        const fetchedData = response.data.map((service) => ({
          ...service,
          isactive: service.isactive === 1 ? 1 : 0, // Ensure the value is correctly mapped
        }));
        setRowData(fetchedData);
      })
      .catch((error) => console.error('Error fetching data:', error));
  }, []);

  



    useEffect(() => {
        document.title = 'Other Service - Calendar Services';
      }, []);

      const handleStatusEdit = (service) => {
        setSelectedService(service); // Save the selected service
        setIsModalOpen(true); // Open the confirmation modal
      };
    
      const confirmStatusChange = () => {
        const loggedInUser = localStorage.getItem('username'); // Get the logged-in user
        const updatedStatus = selectedService.isactive === 1 ? 0 : 1;
      
        axios
          // .put(`http://localhost:3036/other_services/${selectedService.id}/status`, { 
          .put(`${API_BASE_URL}/other_services/${selectedService.id}/status`, { 
              // .put(`${API_BASE_URL}/keyword/${editingKeyword.id}`, updatedKeyword)  
            isactive: updatedStatus,
            mby: loggedInUser // Include 'mby' in the payload
          })
          .then(() => {
            setRowData(
              rowData.map((row) =>
                row.id === selectedService.id ? { ...row, isactive: updatedStatus } : row
              )
            );
            showAlert(
              `Service status updated to ${updatedStatus === 1 ? "Active" : "Inactive"}`,
              "success"
            );
            setIsModalOpen(false); // Close the modal
          })
          .catch((error) => {
            showAlert(error.response?.data?.message || "Error updating status", "error");
            setIsModalOpen(false); // Close the modal
          });
      };
      
    
      const closeModal = () => {
        setIsModalOpen(false); // Close the modal without making changes
      };

  const columnDefs = [
    {
      headerName: "S.No",
      valueGetter: (params) => params.node.rowIndex + 1,
      flex: 1,
      sortable: true,
      filter: true,
      resizable: true,
      
    },
    {
      headerName: "Actions",
      field: "actions",
      cellRenderer: (params) => (
        <div className="flex space-x-2">
          <button className="text-blue-600" onClick={() => handleEdit(params.data)}>Update</button>
          <button className="text-red-600 hover:underline"
           onClick={() => handleDelete(params.data.id)}
           >Delete</button>
        </div>
      ),
      flex: 1,
    },
    {
      headerName: "Status",
      field: "isactive",
      valueFormatter: (params) => (params.value === 1 ? "Active" : "Inactive"),
      flex: 1,
      sortable: true,
      filter: true,
      resizable: true,
      cellStyle: (params) => ({
        color: params.value === 1 ? "green" : "red",
        fontWeight: "bold",
      }),
      cellRenderer: (params) => (
        <div className="flex items-center space-x-2">
          <span>{params.value === 1 ? "Active" : "Inactive"}</span>
          <button
            className="text-blue-600 hover:underline"
            onClick={() => handleStatusEdit(params.data)}
          >
            🖉
          </button>
        </div>
      ),
    },    
    
    { headerName: "Service Name", field: "name", flex: 1, sortable: true, filter: true, resizable: true },
    {
      headerName: "Icon",
      field: "icon",
      flex: 1,
      cellRenderer: (params) => (
        <img
          src={params.value}
          alt="Service Icon"
          style={{ width: "50px", height: "50px", objectFit: "contain" }}
        />
      ),
    },
    { headerName: "Add by", field: "cby", flex: 1, sortable: true, filter: true, resizable: true },
  ];

  const handleSave = () => {
    const loggedInUser = localStorage.getItem('username');
    if (team && iconLink) {
      const payload = { name: team, icon: iconLink, cby: loggedInUser };
      if (editingTeam) {
        payload.mby = loggedInUser;
        // axios.put(`http://localhost:3036/other_services/${editingTeam.id}`, payload)
        axios.put(`${API_BASE_URL}/other_services/${editingTeam.id}`, payload)
        // axios.put(`https://calendarservicesapi.nithra.mobi/other_services/${editingTeam.id}`, payload)
          .then(response => {
            setRowData(rowData.map(row => row.id === editingTeam.id ? response.data : row));
            showAlert('Service updated successfully', 'success');
            resetForm();
            
          })
          .catch(error => showAlert(error.response?.data?.message || 'Error updating data', 'error'));
      } else {
        // axios.post('http://localhost:3036/other_services', payload)
        axios.post(`${API_BASE_URL}/other_services`, payload)
        // axios.post('https://calendarservicesapi.nithra.mobi/other_services', payload)
          .then(response => {
    setRowData([...rowData, { ...payload, id: response.data.id, isactive: 1 }]); // Explicitly set isactive to 1
            showAlert('Service created successfully', 'success');
            resetForm();
          })
          .catch(error => showAlert(error.response?.data?.message || 'Error saving data', 'error'));
      }
    }
  };

  const resetForm = () => {
    setEditingTeam(null);
    setTeam('');
    setIconLink('');
  };

  const handleEdit = (teamData) => {
    setEditingTeam(teamData);
    setTeam(teamData.name || '');
    setIconLink(teamData.icon || '');
    // Scroll to the top of the page
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  

  const handleDelete = (id) => {
    if (window.confirm(`Are you sure you want to delete this team?`)) {
      axios.delete(`https://calendarservicesapi.nithra.mobi/other_services/${id}`)
        .then(() => setRowData(rowData.filter(row => row.id !== id)))
        .catch(error => console.error('Error deleting data:', error));
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setErrors({ ...errors, [name]: '' });
    name === 'team' ? setTeam(value) : setIconLink(value);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!team) newErrors.team = 'Service name is required';


    if (!iconLink) newErrors.iconLink = 'Icon image link is required';
    setErrors(newErrors);
    return !Object.keys(newErrors).length;
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) handleSave();
  };


  const showAlert = (message, type) => {
    setAlert({ message, type });
    setTimeout(() => {
      setAlert({ message: '', type: '' });
    }, 3000); // Alert will be cleared after 3 seconds
  };



  return (
    <div className="bg-gray-100 p-4">
      <div className="max-w-xl mx-auto bg-white shadow-md rounded mb-4 mt-8 ">
        <div className="bg-teal-500 text-white px-5 py-3 rounded-t">
          <h2 className="text-xl font-bold">Add Service</h2>
        </div>
        <form className="p-6 flex flex-col space-y-3" onSubmit={handleFormSubmit}>
          <div>
            <label className="block text-gray-700">Add service:<span className="text-red-500">*</span></label>
            <input
              type="text"
              name="team"
              value={team}
              onChange={handleInputChange}
              placeholder="Enter service name"
              className="w-full p-2 mt-2 border border-gray-300 rounded"
            />
            {errors.team && <span className="text-red-500 text-sm">{errors.team}</span>}
          </div>
          <div>
            <label className="block text-gray-700">Icon image link:<span className="text-red-500">*</span></label>
            <input
              type="text"
              name="iconLink"
              value={iconLink}
              onChange={handleInputChange}
              placeholder="Enter icon image link"
              className="w-full p-2 mt-2 border border-gray-300 rounded"
            />
            {errors.iconLink && <span className="text-red-500 text-sm">{errors.iconLink}</span>}
          </div>
          <div className="flex justify-end">
            <button type="submit" className="px-4 py-2 bg-teal-500 text-white rounded">
              {editingTeam ? 'Update' : 'Save'}
            </button>
          </div>
        </form>
      </div>

      <div className="max-w-5xl mx-auto bg-white shadow-md rounded mb-6">
        <div className="p-6">
          <h2 className="text-teal-500 text-xl font-bold mb-4">View Services</h2>
          <div className="ag-theme-alpine" style={{ height: 500, width: '100%' }}>
          <AgGridReact
  rowData={rowData}
  columnDefs={columnDefs}
  defaultColDef={{ sortable: true, filter: true, editable:true }}
  pagination={true}
  paginationPageSize={5}
  paginationNumberFormatter={(params) => `${params.value}`}
  getRowHeight={() => 60} // Set row height to 60px
/>

          </div>
        </div>
      </div>

      {alert.message && (
  <div className={`fixed top-20 right-4 px-5 py-3 text-white rounded-lg shadow-lg transition-all duration-300 z-50 ${alert.type === 'success' ? 'bg-green-500' : 'bg-red-500'}`}>
    <span>{alert.message}</span>
  </div>
)}


      {/* Confirmation Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded shadow-lg text-center">
            <p className="text-lg font-semibold mb-4">
              Are you sure you want to change the status?
            </p>
            <div className="flex justify-center space-x-4">
              <button
                className="px-4 py-2 bg-green-500 text-white rounded"
                onClick={confirmStatusChange}
              >
                Yes
              </button>
              <button
                className="px-4 py-2 bg-red-500 text-white rounded"
                onClick={closeModal}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}



    </div>
  );
};

export default Otherservices;